import { Injectable } from '@angular/core';
import { Apollo, TypedDocumentNode } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { DocumentNode } from 'graphql';
import { PreviewModeService } from './preview-mode.service';
@Injectable({
    providedIn: 'root'
})
export class ContentfulService {
    constructor(private apollo: Apollo, private preview: PreviewModeService) { }
    /**
     * To query contentful to get page data
     * @param query GQL quey
     * @param variables query variables
     * @returns
     */
    public getPageData(query: DocumentNode | TypedDocumentNode<unknown, any>, variables: any = {}): Observable<any> {
        variables.preview = this.preview.isPreviewMode();
        if(Object.hasOwn(variables, 'slug')) {
            variables.slug = this.parseSlugUrl(variables.slug)
        }
        const gqlQueryOptions: any = {
            query: query,
            variables: variables,
            // Ensure consistent behavior in SSR and browser
            errorPolicy: 'all',
        };
        
        // if preview mode, then fetch fresh data from contentful. No client caching policy will be used.
        if (this.preview.isPreviewMode()) {
            gqlQueryOptions['fetchPolicy'] = "no-cache";
        } else {
            // Use cache-first for better SSR performance
            gqlQueryOptions['fetchPolicy'] = "cache-first";
        }
        
        return this.apollo.query(gqlQueryOptions).pipe(
            map(({ data, error }: any) => {
                if (error) {
                    console.error("gql query error - ", error);
                }
                return { data, error };
            })
        );
    }
    private parseSlugUrl(slug: string) {
        // remove fragments from slug
        if (slug.includes('#')) {
            slug = slug.split('#')[0];
        }
        // remove qsp from slug
        return slug.split('?')[0];
    }
}